import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./chat.css";
import chatImg from "./../../Assets/Image/Leo.png";
import messageSend from "./../../Assets/Icons/Send.jpeg";
import { Link } from "react-router-dom";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { connect } from "react-redux";
import MobileChat from "./MobileChat";

import backButton from "./../../Assets/Icons/back-button.png";
import loadingGif from "./../../Assets/Image/loading.gif";

const Chat = ({ chat }) => {
  const [userId, setUserId] = useState();
  const [connection, setConnection] = useState();
  const [newMessage, setNewMessage] = useState();
  const [friends, setFriends] = useState([]);
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const [activeChatUser, setActiveChatUser] = useState();
  const [newMessageResponse, setNewMessageResponse] = useState();
  const [loading, setLoading] = useState(true);
  const [msgFlag, setMsgFlag] = useState(true);
  const [moreLoadingFlag, setMoreLoadingFlag] = useState(false);
  const [page, setPage] = useState(2);
  const [scroll, setScroll] = useState(true);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const messageRef = useRef();
  const mMessageRef = useRef();
  const buttonRef = useRef();
  let { toUser, fromUser } = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    var decoded = {};
    const gotasteClienttoken = localStorage.getItem("gotasteClienttoken");

    if (gotasteClienttoken != null) {
      try {
        decoded = jwtDecode(gotasteClienttoken);
        // console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }

    if (decoded != null) {
      // console.log(decoded.UserId);
      setUserId(decoded.UserId);
      // joinChat(decoded.UserId);
      getUserChatPreview(decoded.UserId);
    }
  }, []);
  // chat
  useEffect(() => {
    setNewMessageResponse(chat.newResponse);
  }, [chat.newResponse]);
  const getUserChatPreview = (props) => {
    axios
      .get(
        `${process.env.REACT_APP_SECRET}/api/Chatting/chatpreview?id=${props}`
      )
      .then((res) => {
        // console.log(res.data);
        setFriends(res.data);
        setLoading(false);
        // setActiveChatUser(res.data[0]);
      })
      .catch();
  };

  //active chat handler
  useEffect(() => {
    if (activeChatUser) {
      // get the chats
      // axios
      //   .get(
      //     `${process.env.REACT_APP_SECRET}/api/Chatting/getallchattinglistbyuserid?toUserId=${activeChatUser.toUserId}&fromUserId=${activeChatUser.fromUserId}`
      //   )
      //   .then((res) => {
      //     setMessages(res.data);
      //   })
      //   .catch();

      // new api with pagination
      axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/Chatting/getallchattinglistbyuseridwithpagination?toUserId=${activeChatUser.toUserId}&fromUserId=${activeChatUser.fromUserId}&pageNumber=1&noOfRowsPerPage=20`
        )
        .then((res) => {
          setMessages(res.data.chats.reverse());
        })
        .catch();
    }
  }, [activeChatUser]);

  useEffect(() => {
    if (friends) {
      let newItem = friends.filter(
        (friend) => friend.toUserId === toUser && friend.fromUserId === fromUser
      );
      // console.log("new Item");
      if (newItem.length > 0) {
        setActiveChatUser(newItem[0]);
      }
    }
  }, [toUser, fromUser, friends]);

  //   friendHandler
  const activeFriendHandler = (friend) => {
    // check and unread all message

    if (friend.ureadCount > 0) {
      let userIdData =
        userId === friend.fromUserId ? friend.toUserId : friend.fromUserId;
      axios
        .put(
          `${process.env.REACT_APP_SECRET}/api/Chatting/updateunreadmessage?fromUserId=${friend.fromUserId}&toUserId=${friend.toUserId}&userid=${userIdData}`
        )
        .then((res) => {
          let newFriends = friends.map((fnd) => {
            if (fnd.friendUserId === friend.friendUserId) {
              fnd.ureadCount = 0;
              return fnd;
            } else {
              return fnd;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
    navigate(`/chat/${friend.toUserId}/${friend.fromUserId}`);
  };
  // send message handler
  const sendMessaageHandler = () => {
    if (newMessage && msgFlag) {
      setMsgFlag(false);
      axios
        .post(`${process.env.REACT_APP_SECRET}/api/Chatting`, {
          id: "string",
          message: newMessage,
          creationTimestamp: "2023-09-03T04:55:56.412Z",
          lastUpdated: "2023-09-03T04:55:56.412Z",
          fromUserId: activeChatUser.fromUserId,
          toUserId: activeChatUser.toUserId,
          userId: userId,
          edited: true,
          unread: true,
          reportChatFromUserId: "string",
          reportChatReportId: "string",
          reportChatToUserId: "string",
          deleted: true,
        })
        .then((res) => {
          // add the new message to list
          setMessages((oldArray) => [
            ...oldArray,
            {
              id: "string",
              message: newMessage,
              creationTimestamp: "2023-09-03T04:55:56.412Z",
              lastUpdated: "2023-09-03T04:55:56.412Z",
              fromUserId: activeChatUser.fromUserId,
              toUserId: activeChatUser.toUserId,
              userId: userId,
              edited: true,
              unread: true,
              reportChatFromUserId: "string",
              reportChatReportId: "string",
              reportChatToUserId: "string",
              deleted: true,
            },
          ]);
          // empty message box
          setNewMessage("");
          setMsgFlag(true);
          getUserChatPreview(userId);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  // new response
  useEffect(() => {
    if (newMessageResponse && activeChatUser) {
      if (newMessageResponse.userId === activeChatUser.friendUserId) {
        setMessages((oldArray) => [...oldArray, newMessageResponse]);
        getUserChatPreview(userId);
        // read all msg
        let userIdData =
          userId === activeChatUser.fromUserId
            ? activeChatUser.toUserId
            : activeChatUser.fromUserId;
        axios
          .put(
            `${process.env.REACT_APP_SECRET}/api/Chatting/updateunreadmessage?fromUserId=${activeChatUser.fromUserId}&toUserId=${activeChatUser.toUserId}&userid=${userIdData}`
          )
          .then((res) => {
            let newFriends = friends.map((fnd) => {
              if (fnd.friendUserId === activeChatUser.friendUserId) {
                fnd.ureadCount = 0;
                return fnd;
              } else {
                return fnd;
              }
            });
            getUserChatPreview(userId);
          })
          .catch((err) => {
            console.log(err);
          });
        // read all msg
      } else {
        // let indx;
        let newFriendsArray = friends.map((fnd, index) => {
          if (fnd.friendUserId === newMessageResponse.userId) {
            fnd.lastMessage = newMessageResponse.message;
            fnd.ureadCount = fnd.ureadCount + 1;
            // indx = index;
            return fnd;
          } else {
            return fnd;
          }
        });
        getUserChatPreview(userId);
        setFriends(newFriendsArray);
      }
    }
  }, [newMessageResponse]);
  // scroll
  useEffect(() => {
    setIsButtonVisible(true);
    if (messageRef && messageRef.current && scroll) {
      const { scrollHeight, clientHeight } = messageRef.current;
      console.log(scrollHeight - clientHeight);
      messageRef.current.scrollTo({
        left: 0,
        top: scrollHeight - clientHeight,
        behavior: "smooth",
      });
      // messageRef.scrollTop = messageRef.scrollHeight;
      // mMessageRef.scrollTop = messageRef.scrollHeight;
      if (mMessageRef && mMessageRef.current) {
        const { scrollHeight, clientHeight } = mMessageRef.current;
        mMessageRef.current.scrollTo({
          left: 0,
          top: scrollHeight - clientHeight,
          behavior: "smooth",
        });
      }
    }
  }, [messages]);
  // load more handler
  const loadMoreHandler = () => {
    setScroll(false);
    setPage(page + 1);
    setMoreLoadingFlag(true);

    axios
      .get(
        `${process.env.REACT_APP_SECRET}/api/Chatting/getallchattinglistbyuseridwithpagination?toUserId=${activeChatUser.toUserId}&fromUserId=${activeChatUser.fromUserId}&pageNumber=${page}&noOfRowsPerPage=10`
      )
      .then((res) => {
        if (res.data.chats.length > 0) {
          setMoreLoadingFlag(false);
          setMessages((oldArray) => [...res.data.chats.reverse(), ...oldArray]);
        } else {
          setMoreLoadingFlag(false);
          setIsButtonVisible(false);
          setPage(2);
        }
      })
      .catch();
  };

  return (
    <>
      <div className="dextopChat">
        <div className="row">
          <div className="col-3 cahtSidebar">
            <div className="p-3">
              <div className="p-3 fixedSearch">
                <h2 className="ChatHeader">Messages</h2>

                <div className="pb-4">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Search"
                  />
                </div>
              </div>
              {loading === true ? (
                <div>
                  <img
                    src={loadingGif}
                    alt=""
                    className="img-fluid"
                    style={{
                      width: "8rem",
                      height: "8rem",
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "inherit",
                    }}
                  />
                </div>
              ) : (
                <>
                  {friends.length > 0 &&
                    friends.map((friend, index) => (
                      <div
                        to={`/chat/${friend.toUserId}/${friend.fromUserId}`}
                        onClick={() => activeFriendHandler(friend)}
                        key={index}
                        role={"button"}
                        className={`d-flex text-dark text-decoration-none   p-3 my-2 align-items-center ${
                          activeChatUser &&
                          friend.friendUserId === activeChatUser.friendUserId
                            ? "selecedCht"
                            : ""
                        }`}
                      >
                        <div className="me-2">
                          {" "}
                          <img src={chatImg} alt="" />
                        </div>
                        <div className="w-100">
                          <h4 className="m-0 p-0 d-flex justify-content-between">
                            <span>{friend.friendName}</span>

                            {friend.ureadCount > 0 ? (
                              <span className="unread-count">
                                {friend.ureadCount}
                              </span>
                            ) : (
                              ""
                            )}
                          </h4>
                          <p className="lastMessage">
                            {friend.lastMessage.substring(0, 20)}{" "}
                            <span className="fw-bolder">.</span>
                            <span className="ms-1">
                              {friend.creationTime === ""
                                ? "now"
                                : friend.creationTime}
                            </span>
                          </p>
                        </div>
                      </div>
                    ))}
                </>
              )}
            </div>
          </div>
          <div className="col-9 p-0">
            {!activeChatUser ? (
              <div className="no-chat">
                Select A Chat Or Start A New Conversation.
              </div>
            ) : (
              <div ref={messageRef} className="chat">
                <div className="ChatName p-2 mb-3 d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <img src={chatImg} className=" me-3" alt="" />
                    <div className="">
                      <h4 className="p-0 m-0">
                        {activeChatUser && activeChatUser.friendName}
                      </h4>
                      <p className="p-0 m-0">Active</p>
                    </div>
                  </div>
                </div>
                <div className="px-4">
                  {moreLoadingFlag ? (
                    <div>
                      <img
                        src={loadingGif}
                        alt=""
                        className="img-fluid"
                        style={{
                          width: "8rem",
                          height: "8rem",
                          marginLeft: "auto",
                          marginRight: "auto",
                          display: "inherit",
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      {isButtonVisible && messages.length > 9 && (
                        <button
                          ref={buttonRef}
                          onClick={loadMoreHandler}
                          className="load_btn"
                        >
                          load more
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"></path>
                          </svg>
                        </button>
                      )}
                    </>
                  )}

                  {messages.length > 0 &&
                    messages.map((message, index) => {
                      return (
                        <>
                          {message.userId === userId ? (
                            <div className="d-flex  m-2 align-items-center justify-content-end">
                              <div>
                                <h5 className="sendMessage p-2 m-0 ps-3 ">
                                  {message.message}
                                </h5>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex  m-2 align-items-center">
                              <div className="me-2">
                                <img src={chatImg} alt="" />
                              </div>
                              <div>
                                <h5 className="reciveMessage p-2 m-0 ps-3">
                                  {message.message}
                                </h5>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>

                <div className="messageSend">
                  <div className="input-group">
                    <textarea
                      type="text"
                      className="form-control p-1"
                      placeholder="Message"
                      aria-label="Recipient's username"
                      aria-describedby="button-addon2"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                    />
                    <button
                      onClick={sendMessaageHandler}
                      className="btn  sendbtn"
                      type="button"
                      id="button-addon2"
                    >
                      <i className="fa-solid fa-paper-plane"></i>
                      {/* <img className='img-fluid ' src={messageSend} alt="" /> */}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* for Mobile */}
      <div className="mobileChat">
        <div className="col-12 p-0">
          <div ref={mMessageRef} className="chat">
            <div className="ChatName p-3 mb-3 d-flex align-items-center">
              <Link to="/chat">
                <img className="backButton img-fuild" src={backButton} alt="" />
              </Link>
              <h3 className="p-0 m-0">
                {activeChatUser && activeChatUser.friendName}
              </h3>
            </div>
            <div className="msg_container">
              <div className="px-2">
                {moreLoadingFlag ? (
                  <div>
                    <img
                      src={loadingGif}
                      alt=""
                      className="img-fluid"
                      style={{
                        width: "8rem",
                        height: "8rem",
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "inherit",
                      }}
                    />
                  </div>
                ) : (
                  <>
                    {isButtonVisible && messages.length > 9 && (
                      <button
                        ref={buttonRef}
                        onClick={loadMoreHandler}
                        className="load_btn"
                      >
                        load more
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"></path>
                        </svg>
                      </button>
                    )}
                  </>
                )}
                {messages.length > 0 &&
                  messages.map((message, index) => {
                    return (
                      <>
                        {message.userId === userId ? (
                          <div className="d-flex  m-2 align-items-center justify-content-end">
                            <div>
                              <h6 className="sendMessage p-2 m-0 ps-3 ">
                                {message.message}
                              </h6>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex  m-2 align-items-center">
                            <div className="me-2">
                              <img src={chatImg} alt="" />
                            </div>
                            <div>
                              <h6 className="reciveMessage p-2 m-0 ps-3">
                                {message.message}
                              </h6>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
            </div>

            <div className="messageSend">
              <div class="input-group">
                <textarea
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  type="text"
                  class="form-control"
                  placeholder="Message"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                />
                <button
                  onClick={sendMessaageHandler}
                  class="btn  sendbtn"
                  type="button"
                  id="button-addon2"
                >
                  <img className="img-fluid " src={messageSend} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  chat: state.chatReducer,
});
export default connect(mapStateToProps)(Chat);
